import { createSelector } from "reselect";
import { AppState } from "app/shared/store/root.reducer";

const getStore = (state: AppState) => state.card;
const getResListCard = (state: AppState) => state.card.resListCard;
const getStatusListCard = (state: AppState) => state.card.statusListCard;
const getLimit4NumDigit = (state: AppState) => state.card.limit4NumDigit;

const getResCardDetail = (state: AppState) => state.card.resCardDetail;
const getStatusCardDetail = (state: AppState) => state.card.statusCardDetail;
const getCardFullNum = (state: AppState) => state.card.cardNumFull;

const getResCardConfirm = (state: AppState) => state.card.resCardConfirm;
const getStatusCardConfirm = (state: AppState) => state.card.statusCardConfirm;

const getResCardAuth = (state: AppState) => state.card.resCardAuth;
const getStatusCardAuth = (state: AppState) => state.card.statusCardAuth;

const getResCardHistory = (state: AppState) => state.card.resCardHistory;
const getStatusCardHistory = (state: AppState) => state.card.statusCardHistory;

const getResCardStatement = (state: AppState) => state.card.resCardStatement;
const getStatusCardStatement = (state: AppState) => state.card.statusCardStatement;

const getResCardPhysicalRegister = (state: AppState) => state.card.resCardPhysicalRegister;
const getStatusCardPhysicalRegister = (state: AppState) => state.card.statusPhysicalRegister;

export const getCardStoreSelector = createSelector(getStore, (data) => data);
export const getCardListSelector = createSelector(getResListCard, (data) => data);
export const getStatusListCardSelector = createSelector(getStatusListCard, (status) => status);
export const getLimit4NumDigitSelector = createSelector(getLimit4NumDigit, (num) => num);

export const getResponseCardDetailSelector = createSelector(getResCardDetail, (data) => data);
export const getStatusCardDetailSelector = createSelector(getStatusCardDetail, (status) => status);
export const getCardFullNumSelector = createSelector(getCardFullNum, (num) => num);

export const getResCardConfirmSelector = createSelector(getResCardConfirm, (data) => data);
export const getStatusCardConfirmSelector = createSelector(getStatusCardConfirm, (status) => status);

export const getResCardAuthSelector = createSelector(getResCardAuth, (data) => data);
export const getStatusCardAuthSelector = createSelector(getStatusCardAuth, (status) => status);

export const getResCardHistorySelector = createSelector(getResCardHistory, (data) => data);
export const getStatusCardHistorySelector = createSelector(getStatusCardHistory, (status) => status);

export const getResCardStatementSelector = createSelector(getResCardStatement, (data) => data);
export const getStatusCardStatementSelector = createSelector(getStatusCardStatement, (status) => status);

export const getResCardPhysicalRegisterSelector = createSelector(getResCardPhysicalRegister, (data) => data);
export const getStatusCardPhysicalRegisterSelector = createSelector(getStatusCardPhysicalRegister, (status) => status);
